
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class StageMembersGrid extends Serenity.EntityGrid<StageMembersRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.StageMembers'; }
        protected getDialogType() { return StageMembersDialog; }
        protected getIdProperty() { return StageMembersRow.idProperty; }
        protected getInsertPermission() { return StageMembersRow.insertPermission; }
        protected getLocalTextPrefix() { return StageMembersRow.localTextPrefix; }
        protected getService() { return StageMembersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}